// This script should be saved as 'gallery-script.js' and linked in your HTML file
// Add this line in your HTML <head> section:
// {{ 'gallery-script.js' | asset_url | script_tag }}

document.addEventListener('DOMContentLoaded', function() {
    // Lazy loading code
    let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
    let active = false;

    const lazyLoad = function() {
        if (active === false) {
            active = true;

            setTimeout(function() {
                lazyImages.forEach(function(lazyImage) {
                    if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.classList.remove("lazy");

                        lazyImages = lazyImages.filter(function(image) {
                            return image !== lazyImage;
                        });

                        if (lazyImages.length === 0) {
                            document.removeEventListener("scroll", lazyLoad);
                            window.removeEventListener("resize", lazyLoad);
                            window.removeEventListener("orientationchange", lazyLoad);
                        }
                    }
                });

                active = false;
            }, 200);
        }
    };

    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);

    // Gallery functionality
    const filterForm = document.getElementById('filter-form');
    const galleryItems = document.querySelectorAll('.gallery-item');
    
    // Video popup functionality
    const videoPopup = document.getElementById('videoPopup');
    const closePopup = videoPopup.querySelector('.close-popup');
    const wistiaContainer = document.getElementById('wistiaContainer');
    const youtubePlayer = document.getElementById('youtubePlayer');
    const videoContainer = videoPopup.querySelector('.video-container');

    let currentWistiaPlayer = null;

    function openVideoPopup(videoSrc) {
        const isYouTube = videoSrc.includes('youtube.com') || videoSrc.includes('youtu.be');
        
        if (isYouTube) {
            wistiaContainer.style.display = 'none';
            youtubePlayer.style.display = 'block';
            youtubePlayer.src = videoSrc;
            videoContainer.classList.remove('portrait');
        } else {
            // Clear previous Wistia player if exists
            if (currentWistiaPlayer) {
                currentWistiaPlayer.remove();
            }

            wistiaContainer.style.display = 'block';
            youtubePlayer.style.display = 'none';
            videoContainer.classList.add('portrait');

            // Create a new div for the Wistia player
            const wistiaPlayerDiv = document.createElement('div');
            wistiaPlayerDiv.className = 'wistia_embed wistia_async_' + videoSrc + ' videoFoam=true';
            wistiaContainer.appendChild(wistiaPlayerDiv);

            window._wq = window._wq || [];
            _wq.push({
                id: videoSrc,
                onReady: function(video) {
                    currentWistiaPlayer = video;
                    video.play();
                }
            });
        }
        
        videoPopup.style.display = 'flex';
    }

    closePopup.addEventListener('click', () => {
        videoPopup.style.display = 'none';
        if (currentWistiaPlayer) {
            currentWistiaPlayer.remove();
            currentWistiaPlayer = null;
        }
        wistiaContainer.innerHTML = '';
        youtubePlayer.src = '';
    });

    videoPopup.addEventListener('click', (e) => {
        if (e.target === videoPopup) {
            closePopup.click();
        }
    });

    // Define tag categories
    const tagCategories = {
        typ: ['Bild', 'Video', 'Omdöme'],
        miljo: ['Invändigt', 'Utvändigt'],
        fargProdukt: ['Äggoljetempera', 'Linoljefärg', 'Slamfärg', 'Pigment', 'Linoljesåpa', 'Linolja', 'Schellack', 'Träolja', 'Kalkbruk', 'Kakelugnsfog', 'Roslagsmahogny', 'Lasyr', 'Detaljer'],
        farg: ['Grå', 'Gul', 'Vit', 'Svart', 'Grön', 'Blå', 'Röd', 'Rosa', 'Brun', 'Beige']
    };

    // Function to create checkbox
    function createCheckbox(tag, category) {
        const label = document.createElement('label');
        label.className = 'filter-option';
        label.innerHTML = `
            <input type="checkbox" name="tag" value="${tag}" data-category="${category}" class="filter-checkbox">
            <span class="filter-icon--checkbox">
                <svg class="checkmark" aria-hidden="true" focusable="false" role="presentation" width="14" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
                    <path class="checkmark__check" fill="none" stroke="#fff" stroke-width="2" d="M2.5 7L5.5 10L11.5 4"></path>
                </svg>
            </span>
            <span class="filter-label">${tag}</span>
        `;
        return label;
    }

    // Populate filter columns
    function populateFilters() {
        const typColumn = document.querySelector('#typ-column .filter-options');
        const miljoColumn = document.querySelector('#miljo-column .filter-options');
        const fargProduktColumn = document.querySelector('#farg-produkt-column .filter-options');
        const fargColumn = document.querySelector('#farg-column .filter-options');

        tagCategories.typ.forEach(tag => typColumn.appendChild(createCheckbox(tag, 'typ')));
        tagCategories.miljo.forEach(tag => miljoColumn.appendChild(createCheckbox(tag, 'miljo')));
        tagCategories.fargProdukt.forEach(tag => fargProduktColumn.appendChild(createCheckbox(tag, 'fargProdukt')));
        tagCategories.farg.forEach(tag => fargColumn.appendChild(createCheckbox(tag, 'farg')));
    }

    populateFilters();

    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
    
    const urlTag = getUrlParameter('tag');
    if (urlTag) {
        const checkbox = filterForm.querySelector(`input[value="${urlTag}"]`);
        if (checkbox) {
            checkbox.checked = true;
        }
    }
    
    function updateGallery() {
        const selectedTags = {
            typ: [],
            miljo: [],
            fargProdukt: [],
            farg: []
        };

        filterForm.querySelectorAll('input[name="tag"]:checked').forEach(checkbox => {
            const category = checkbox.dataset.category;
            selectedTags[category].push(checkbox.value.trim());
        });
        
        galleryItems.forEach(item => {
            const itemTags = item.dataset.tags.split(',').map(tag => tag.trim());
            const showItem = Object.entries(selectedTags).every(([category, tags]) => {
                return tags.length === 0 || tags.some(tag => itemTags.includes(tag));
            });
            item.style.display = showItem ? '' : 'none';
        });
    }
    
    filterForm.addEventListener('change', updateGallery);
    
    updateGallery();

    galleryItems.forEach(item => {
        const videoOverlay = item.querySelector('.video-overlay');
        const articleLink = item.querySelector('.article-link');
        
        if (videoOverlay) {
            const videoSrc = item.dataset.videoId;
            if (videoSrc) {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    openVideoPopup(videoSrc);
                });
            }
        }
        
        if (articleLink) {
            articleLink.addEventListener('click', (e) => {
                e.stopPropagation(); // Prevent triggering video popup if it's an article
            });
        }
    });
});